export default {
  clone: 'Clone',
  endate_camp: 'End Date',
  startdate_camp: 'Start Date',
  clone_camp: 'Clone Campaign',
  new_camp: 'New campaign name',
  noresult: 'No results found'
}
